<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<form [formGroup]="formService.form">
  <odc-instant-search-editor
    data-test-id="instant-search"
    [formControlName]="formServiceClass.SEARCH_FIELD"
    [searchResultItemList]="searchResultItemList"
    label="Bearbeiter suchen"
    placeholder="Bearbeiter suchen"
    focusOnSearchField="true"
    previewSearchMinLength="0"
    variant="user-profile"
    (searchQueryChanged)="handleSearchQueryChanged($event.searchBy)"
  >
    <alfa-user-profile-search-results-container [searchResults]="userSearchResults" [showUnassigned]="showUnassigned" />
  </odc-instant-search-editor>
</form>
